export const CAN_VIEW_JOB = 'CAN_VIEW_JOB'
export const CAN_ADMINISTER_USER = 'CAN_ADMINISTER_USER'
export const CAN_VIEW_REPORTS = 'CAN_VIEW_REPORTS'
export const CAN_VIEW_INVENTORY = 'CAN_VIEW_INVENTORY'
export const CAN_EDIT_INVENTORY = 'CAN_EDIT_INVENTORY'
export const CAN_VIEW_ADMIN_DASHBOARD = 'CAN_VIEW_ADMIN_DASHBOARD'
export const CAN_REORDER_WARRANTY_CREW = 'CAN_REORDER_WARRANTY_CREW'
export const CAN_REORDER_PEBBLE_CREWS = 'CAN_REORDER_PEBBLE_CREWS'

export const CAN_VIEW_ROLES = 'CAN_VIEW_ROLES'
export const CAN_EDIT_ROLES = 'CAN_EDIT_ROLES'
export const CAN_VIEW_ESTIMATE = 'CAN_VIEW_ESTIMATE'
export const CAN_EDIT_ESTIMATE = 'CAN_EDIT_ESTIMATE'
export const CAN_VIEW_GUNITE_SCHEDULE = 'CAN_VIEW_GUNITE_SCHEDULE'
export const CAN_EDIT_GUNITE_SCHEDULE = 'CAN_EDIT_GUNITE_SCHEDULE'
export const CAN_VIEW_GUNITE_JOB_ALL = 'CAN_VIEW_GUNITE_JOB_ALL'
export const CAN_EDIT_GUNITE_JOB_ALL = 'CAN_EDIT_GUNITE_JOB_ALL'
export const CAN_VIEW_GUNITE_JOB_ASSIGNED_TO_USER = 'CAN_VIEW_GUNITE_JOB_ASSIGNED_TO_USER'
export const CAN_EDIT_GUNITE_JOB_ASSIGNED_TO_USER = 'CAN_EDIT_GUNITE_JOB_ASSIGNED_TO_USER'
export const CAN_VIEW_PLASTER_SCHEDULE = 'CAN_VIEW_PLASTER_SCHEDULE'
export const CAN_EDIT_PLASTER_SCHEDULE = 'CAN_EDIT_PLASTER_SCHEDULE'
export const CAN_VIEW_PLASTER_JOBS_ALL = 'CAN_VIEW_PLASTER_JOBS_ALL'
export const CAN_EDIT_PLASTER_JOBS_ALL = 'CAN_EDIT_PLASTER_JOBS_ALL'
export const CAN_VIEW_PLASTER_JOBS_ASSIGNED_TO_USER = 'CAN_VIEW_PLASTER_JOBS_ASSIGNED_TO_USER'
export const CAN_EDIT_PLASTER_JOBS_ASSIGNED_TO_USER = 'CAN_EDIT_PLASTER_JOBS_ASSIGNED_TO_USER'
export const CAN_VIEW_WARRANTY_JOBS = 'CAN_VIEW_WARRANTY_JOBS'
export const CAN_EDIT_WARRANTY_JOBS = 'CAN_EDIT_WARRANTY_JOBS'
export const CAN_VIEW_REPORT_CALENDAR_GUNITE = 'CAN_VIEW_REPORT_CALENDAR_GUNITE'
export const CAN_VIEW_REPORT_CALENDAR_PEBBLE = 'CAN_VIEW_REPORT_CALENDAR_PEBBLE'
export const CAN_VIEW_REPORT_CUSTOMER_CONTACT_LIST = 'CAN_VIEW_REPORT_CUSTOMER_CONTACT_LIST'
export const CAN_VIEW_REPORT_CUSTOMER_TOP_50_CONTACTS = 'CAN_VIEW_REPORT_CUSTOMER_TOP_50_CONTACTS'
export const CAN_VIEW_REPORT_COVERAGE = 'CAN_VIEW_REPORT_COVERAGE'
export const CAN_VIEW_REPORT_PER_COMPANY_JOB = 'CAN_VIEW_REPORT_PER_COMPANY_JOB'
export const CAN_VIEW_REPORT_SLURRY_PICKUP = 'CAN_VIEW_REPORT_SLURRY_PICKUP'
export const CAN_VIEW_REPORT_YEAR_OVER_YEAR_GUNITE = 'CAN_VIEW_REPORT_YEAR_OVER_YEAR_GUNITE'
export const CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE = 'CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE'
export const CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE_REMODEL = 'CAN_VIEW_REPORT_YEAR_OVER_YEAR_PEBBLE_REMODEL'
export const CAN_VIEW_REPORT_INVENTORY = 'CAN_VIEW_REPORT_INVENTORY'
export const CAN_VIEW_COLOR_RECIPE = 'CAN_VIEW_COLOR_RECIPE'
export const CAN_EDIT_COLOR_RECIPE = 'CAN_EDIT_COLOR_RECIPE'

export const CAN_EXPORT_DATA = 'CAN_EXPORT_DATA'
export const CAN_DELETE_JOB = 'CAN_DELETE_JOB'

export const CAN_VIEW_MOBILE_DASHBOARD = 'CAN_VIEW_MOBILE_DASHBOARD'
export const CAN_VIEW_MOBILE_SEARCH = 'CAN_VIEW_MOBILE_SEARCH'
export const CAN_VIEW_MOBILE_MAP = 'CAN_VIEW_MOBILE_MAP'
export const CAN_VIEW_MOBILE_WORK_ORDERS = 'CAN_VIEW_MOBILE_WORK_ORDERS'
export const CAN_SUPERVISE_OTHERS = 'CAN_SUPERVISE_OTHERS'
export const CAN_MOBILE_UPLOAD = 'CAN_MOBILE_UPLOAD'
export const CAN_EDIT_MOBILE_PRESITE = 'CAN_EDIT_MOBILE_PRESITE'

export const CAN_SCHEDULE_PRESITE = 'CAN_SCHEDULE_PRESITE'

export const CAN_VIEW_MY_JOBS = 'CAN_VIEW_MY_JOBS'
export const CAN_EDIT_FOREMAN_BOULDER_WORK_ORDER = 'CAN_EDIT_FOREMAN_BOULDER_WORK_ORDER'
export const CAN_EDIT_FOREMAN_GUNITE_WORK_ORDER = 'CAN_EDIT_FOREMAN_GUNITE_WORK_ORDER'
export const CAN_EDIT_FOREMAN_PEBBLE_DAILY_WORK_ORDER = 'CAN_EDIT_FOREMAN_PEBBLE_DAILY_WORK_ORDER'
export const CAN_EDIT_FOREMAN_PEBBLE_WORK_ORDER = 'CAN_EDIT_FOREMAN_PEBBLE_WORK_ORDER'
export const CAN_EDIT_FOREMAN_PREP_WORK_ORDER = 'CAN_EDIT_FOREMAN_PREP_WORK_ORDER'
export const CAN_SEND_BUILDER_EMAIL = 'CAN_SEND_BUILDER_EMAIL'
export const CAN_VIEW_PRINT_QUEUE = 'CAN_VIEW_PRINT_QUEUE'
export const CAN_REORDER_GUNITE_CREW = 'CAN_REORDER_GUNITE_CREW'
export const CAN_REORDER_BOULDER_CREW = 'CAN_REORDER_BOULDER_CREW'

export const CAN_MOVE_ALL_SCHEDULE_BOARD_CARDS = 'CAN_MOVE_ALL_SCHEDULE_BOARD_CARDS'

//Mobile Menu 
export const CAN_VIEW_JOB_MENU = 'CAN_VIEW_JOB_MENU'
export const CAN_VIEW_MAP_SEARCH_MENU = 'CAN_VIEW_MAP_SEARCH_MENU'
export const CAN_VIEW_INVENTORY_MENU = 'CAN_VIEW_INVENTORY_MENU'
export const CAN_VIEW_REPORTS_MENU = 'CAN_VIEW_REPORTS_MENU'
export const CAN_VIEW_SCHEDULE_MENU = 'CAN_VIEW_SCHEDULE_MENU'

// User-level actions
export const IS_SUBCONTRACTOR = 'IS_SUBCONTRACTOR'
